import { motion } from 'motion/react';
import { AnimatedWbkLogo } from '@wbk/svg';

type Props = {
  children: React.ReactNode;
  hasNextPage: boolean;
  fetchNextPage: () => void;
};

const PaginatedPageWrapper = ({ children, hasNextPage, fetchNextPage }: Props) => {
  return (
    <>
      {children}
      {hasNextPage && (
        <motion.div className='py-12' onViewportEnter={fetchNextPage}>
          <AnimatedWbkLogo className='mx-auto h-20 w-52' />
        </motion.div>
      )}
    </>
  );
};

export default PaginatedPageWrapper;
